<wuc-card cardStyle="tertiary" padding="large">
    <ins-passport-info [relation]="relation"></ins-passport-info>
    <br />
    <ins-passport-insurances [passportProducts]="passportProducts"></ins-passport-insurances>
</wuc-card>
